
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';

// Removed all projects as requested by the user
const projects = [];

const socialLinks = [
  {
    id: 1,
    platform: "Mirror",
    username: "specialagentk.eth",
    url: "http://mirror.xyz/specialagentk.eth/",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
        <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
        <circle cx="12" cy="12" r="3"></circle>
      </svg>
    )
  },
  {
    id: 2,
    platform: "Warpcast",
    username: "@specialagentk",
    url: "https://warpcast.com/specialagentk",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
        <path d="M22 8.5c0 1.5-.5 2.5-2 3 1.5.5 2 1.5 2 3v1c0 2-1 3-3 3h-6c-2 0-3-1-3-3v-1c0-1.5.5-2.5 2-3-1.5-.5-2-1.5-2-3v-1c0-2 1-3 3-3h6c2 0 3 1 3 3z"></path>
        <path d="M8 8.5c0 1.5-.5 2.5-2 3 1.5.5 2 1.5 2 3v1c0 2-1 3-3 3H3c-2 0-3-1-3-3v-1c0-1.5.5-2.5 2-3-1.5-.5-2-1.5-2-3v-1c0-2 1-3 3-3h2c2 0 3 1 3 3z"></path>
      </svg>
    )
  },
  {
    id: 3,
    platform: "YouTube",
    username: "Layer 2 Lounge",
    url: "https://www.youtube.com/channel/UC2btVEifhEZQUNXhtevFtyg",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
        <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"></path>
        <path d="m10 15 5-3-5-3z"></path>
      </svg>
    )
  },
  {
    id: 4,
    platform: "Lenster",
    username: "@specialagentk.lens",
    url: "https://hey.xyz/u/specialagentk.lens",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M16.2 7.8c-2-2-5.4-2-7.4 0L8 8.6"></path>
        <path d="M7.8 7.8c2-2 5.4-2 7.4 0l.8.8"></path>
        <path d="M7.8 16.2c2 2 5.4 2 7.4 0l.8-.8"></path>
        <path d="M16.2 16.2c-2 2-5.4 2-7.4 0L8 15.4"></path>
      </svg>
    )
  }
];

const Work: React.FC = () => {
  return (
    <section id="work" className="py-20 bg-cyber-gray bg-opacity-20">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-pixel mb-8 inline-block relative">
          <span className="text-shadow-glow">{'\u003E'} Things of Interest</span>
          <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-cyber-green"></span>
        </h2>
        
        {/* Projects section is now empty since all projects were removed */}
        {projects.length > 0 && (
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {projects.map((project) => (
              <div key={project.id} className="cyber-box hover:border-cyber-green-muted transition-colors duration-300 group">
                <span></span>
                <div className="p-4">
                  <h3 className="text-xl font-bold mb-2 text-cyber-green group-hover:text-shadow-glow transition-all">{project.title}</h3>
                  <p className="mb-4 text-sm">{project.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {project.tags.map((tag, index) => (
                      <span key={index} className="text-xs bg-cyber-darkgray px-2 py-1 border border-cyber-green text-cyber-green">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <span></span>
              </div>
            ))}
          </div>
        )}
        
        <h3 className="text-2xl md:text-3xl font-pixel mb-6 inline-block relative">
          <span className="text-shadow-glow">{'\u003E'} Online Presence</span>
          <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-cyber-green"></span>
        </h3>
        
        <div className="grid md:grid-cols-2 gap-4">
          {socialLinks.map((social) => (
            <a 
              key={social.id} 
              href={social.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="cyber-box bg-cyber-darkgray bg-opacity-30 hover:bg-opacity-50 hover:border-cyber-green-muted transition-all duration-300 group"
            >
              <span></span>
              <div className="p-4 flex items-center">
                <div className="mr-4 text-cyber-green">{social.icon}</div>
                <div>
                  <h4 className="text-lg font-bold text-cyber-green group-hover:text-shadow-glow transition-all">{social.platform}</h4>
                  <p className="text-cyber-green-muted">{social.username}</p>
                </div>
                <div className="ml-auto text-cyber-green">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </div>
              <span></span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Work;
